<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />
          <!-- /Page Header -->

          <!-- Settings Menu -->
          <settings-tabs></settings-tabs>
          <!-- /Settings Menu -->

          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <!-- Prefixes -->
              <div class="card">
                <div class="card-body">
                  <div class="settings-header">
                    <website-sidebar :file_id="file_id" :mapping_id='mapping_id'
                      :show_assign_data='show_assign_data'></website-sidebar>
                  </div>
                  <form @submit.prevent="validateData" v-if="validateOptions.length > 0">
                    <div class="row align-items-center py-4">
                      <div class="col"></div>
                      <div class="col-md-7">
                        <div class="row">
                          <div class="col-md-5">
                            <div class="storage-wrap prefer-wrap" v-for="val in validateOptions" :key="val.id">
                              <div class="storage-icon">
                                <h6>{{ val.name }}</h6>
                              </div>
                              <div class="setting-gateway">
                                <div class="status-toggle">
                                  <input type="checkbox" :id="val.id" class="check" :value="val.id"
                                    v-model="formData.modules" @change="handleModuleChange(val)" />
                                  <label :for="val.id" class="checktoggle"> </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-7">
                            <textarea class="form-control" rows="5" v-model="formData.import_description"></textarea>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-5">
                            <div class="storage-wrap prefer-wrap">
                              <label class="form-check-label mb-0" for="flexSwitchCheckChecked">Update Existing</label>
                              <div class="form-check m-0 ">
                                <div class="status-toggle toggleMode">
                                <input class="form-check-input check" type="checkbox" role="switch"
                                  id="flexSwitchCheckChecked" :checked="formData.show_assign_data === 1"
                                  @change="toggleCheckox"
                                  :class="{ 'switch-on': formData.show_assign_data === 1, 'switch-off': formData.show_assign_data === 0 }">
                                  <label for="flexSwitchCheckChecked" class="checktoggle mt-1"> </label>
                                </div>
                              </div>
                              <label class="form-check-label mb-0" for="flexSwitchCheckChecked">Create New</label>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div class="col"></div>
                    </div>
                    <div class="submit-button">
                      <div class="row">
                        <div class="col-md-6">
                          <button type="submit" class="btn btn-primary"
                            :disabled="formData?.modules?.length === 0">Validate</button>
                        </div>
                        <div class="col-md-6 text-end">
                          <router-link v-if="isValidated" class="btn btn-teal"
                            :to="{ path: '/data-import/map-data', query: { useMapping: mapping_id, fileId: file_id, showAssignData: show_assign_data } }">
                            Ready to map</router-link>
                          <!-- <router-link v-if="isValidated" class="btn btn-teal" :to="{ path: '/data-import/create-mode', query: {useMapping: mapping_id, fileId: file_id } }">
                            Create Mode</router-link> -->
                        </div>
                      </div>
                    </div>
                  </form>
                  <div class="row" v-else>
                    <div class="col"></div>
                    <div class="col-md-7 py-3 bg-light">
                      <p class="text-center "><i class="ion-information-circled"></i> Please upload a file</p>
                    </div>
                    <div class="col"></div>
                  </div>
                </div>
              </div>
              <!-- /Prefixes -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { message } from "ant-design-vue";

export default {
  data() {
    return {
      title: "Settings",
    };
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const isValidated = ref(false);
    const validateOptions = ref([]);
    const tooMany = ref(["Too few data fields", "Too many data fields"]);
    const file_id = ref(null);
    if (route.query.fileId || localStorage.getItem('fileId')) {
      file_id.value = route.query.fileId || localStorage.getItem('fileId');
    }
    const mapping_id = ref(route.query.useMapping || null);

    const show_assign_data = ref(route.query.showAssignData || "true")

    const formData = ref({
      id: file_id,
      modules: [], // This will store the selected IDs
      import_relations: 0,
      only_create_new: 0,
      too_few_data_fields: 0,
      too_many_data_fields: 0,
      import_description: "",
      show_assign_data: 1
    });

    // Fetch data on mount
    const fetchValidData = async (id) => {
      try {
        const data = await store.dispatch("dataimport/fetchValidateData", id);
        validateOptions.value = data.all_modules;
        Object.assign(formData.value.modules, data.selected_modules);
        if (data.import_description) {
          formData.value.import_description = data.import_description;
        }
        formData.value.show_assign_data = data.show_assign_data;
      } catch (error) {
        console.error("Error fetching dataimport data:", error);
      }
    };
    // Update formData based on "Too few" and "Too many" checkboxes
    const updateTooMany = (index, isChecked) => {
      if (index === 0) {
        formData.value.too_few_data_fields = isChecked ? 1 : 0;
      } else if (index === 1) {
        formData.value.too_many_data_fields = isChecked ? 1 : 0;
      }
    };
    // Submit form
    const validateData = async () => {
      try {
        if (formData.value?.modules.length === 0) {
          message.error("Please select at least one module")
          return;
        }
        const response = await store.dispatch("dataimport/validateFile", formData.value);
        if (response.status) {
          show_assign_data.value = formData.value.show_assign_data ? "true" : "false";
          isValidated.value = true;
          router.replace({
            path: '/data-import/validate',
            query: {
              ...route.query,
              showAssignData: show_assign_data.value
            }
          });
        }
      } catch (error) {
        console.error("Validation failed:", error);
      }
    };
    // Find the ID of "opportunity.update"
    const opportunityUpdateId = computed(() => {
      return validateOptions.value.find((item) => item.alias === "opportunity.update")?.id;
    });

    // Watch for changes in modules
    const handleModuleChange = (selectedOption) => {
      if (selectedOption.alias === "opportunity.update") {
        // If "opportunity.update" is checked, uncheck all others
        formData.value.modules = [selectedOption.id];
      } else {
        // If any other checkbox is checked, remove "opportunity.update"
        formData.value.modules = formData.value.modules.filter(
          (id) => id !== opportunityUpdateId.value
        );
      }
    };

    const toggleCheckox = (event) => {
      formData.value.show_assign_data = event.target.checked ? 1 : 0
      // show_assign_data.value = event.target.checked ? 1 : 0
    }

    // When component is mounted
    onMounted(async () => {
      const fileId = route.query.fileId || localStorage.getItem('fileId');
      if (fileId) {
        fetchValidData(fileId);
      }
    });

    return {
      validateOptions,
      opportunityUpdateId,
      handleModuleChange,
      formData,
      tooMany,
      updateTooMany,
      validateData,
      isValidated,
      file_id,
      mapping_id,
      show_assign_data,
      toggleCheckox
    };
  }
};
</script>
<style>

.storage-wrap label{
  font-weight: 600 !important;
}

.toggleMode .checktoggle{
  background-color: #1ABE17 !important;
  border-color: #1ABE17 !important;
}
</style>
